import { createStore }  from "redux";
import {UPDATE_FORM,
        UPDATE_RECIPE,} from '../actions/memberAction';

const initialState = {
  GameModeSelect   : "kokugo" , // 選択したゲームモード
  CalcSelect       : "tashi"  , // 計算式の選択
  GakunenSelect    : "1"      , // 学年の選択
  GameUI           : ""       , // ゲームボーイUIの状態管理
  SelectYesNo      : "yes"    , // 「はい」「いいえ」の選択状態
};

const reducer = (state = initialState ,action) => {
    switch (action.type) {
        case UPDATE_FORM:
            let formState = {...state};
            formState = action.payload;
            return formState;
        case UPDATE_RECIPE:
            let recipeState = {...state};
            recipeState = action.payload;
            return recipeState;
        default:
            return state;
    }
};

const store = createStore(reducer);

export default store;